<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row">
            <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                      <div class="float-right">
                          <i class="dripicons-user-group report-main-icon"></i>
                      </div>
                      <h5><span class="badge badge-success">Total Retur</span></h5>
                      <h3 class="my-3">
                          <span>{{ totalRetur | currency }}</span>
                      </h3>
                  </div>
                  <!--end card-body-->
              </div>
              <!--end card-->
            </div>
            <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                      <div class="float-right">
                          <i class="dripicons-user-group report-main-icon"></i>
                      </div>
                      <h5><span class="badge badge-success">Total Journal</span></h5>
                      <h3 class="my-3">
                          <span>{{ totalJournal | currency }}</span>
                      </h3>
                  </div>
                  <!--end card-body-->
              </div>
              <!--end card-->
            </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h5>Sales Retur List</h5>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                    <div class="form-inline ml-auto">
                    <div class="button-group">
                        <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                            <i class="fa fa-filter" aria-hidden="true"></i>
                            Filter
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu p-2" >
                            <span>Company:</span>
                            <div clsalesmanass="dropdown-divider"></div>
                            <li v-for="c in companyList" :key="c.id">
                            <a href="#" class="small" tabIndex="-1">
                                <input type="checkbox" :value="c.company_no" v-model="filterCompany"/>&nbsp; {{ c.name }}
                            </a>
                            </li>
                        </ul>
                        <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="addReturn">
                          <i class="fa fa-plus" aria-hidden="true"></i> New
                        </button>
                        <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                            <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                        </button>
                        rows:
                        <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                            <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                        </select>
                        <span class="mr-1">
                            Total rows: <b>{{ filterData.length }}</b>
                        </span>
                        <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                    </div>
                    <div class="form-group mx-sm-3 mb-2">
                        <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                    </div>
                    <span class="mr-1">{{ currentPage }} / {{ pageLength }}</span>
                    <nav aria-label="Page navigation example" class="pull-right">
                        <ul class="pagination">
                            <li class="page-item">
                                <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                                </a>
                            </li>
                            <li class="page-item">
                                <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                </a>
                            </li>
                        </ul>
                    </nav>
                    </div>
                    <table class="table table-item mb-0 table-sm table-hover">
                        <thead>
                            <tr>
                                <th>
                                <label class="form-checkbox">
                                    <input type="checkbox" v-model="selectAll" @click="select">
                                    <i class="form-icon"></i>
                                </label>
                                </th>
                                <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                                    {{ t.name }}
                                    <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                          <tr v-if="filterData.length < 1">
                              <td colspan="15" style="text-align: center;"><i>No Data</i></td>
                          </tr>
                          <tr v-for="u in filterData" v-bind:key="u.id">
                              <td>
                                  <label class="form-checkbox">
                                      <input type="checkbox" :value="u.id" v-model="selected">
                                      <i class="form-icon"></i>
                                  </label>
                              </td>
                              <td>
                                  <span class="badge badge-primary" v-if="u.status === 'approve'">{{ u.status }}</span>
                                  <span class="badge badge-success" v-else-if="u.status === 'open'">{{ u.status }}</span>
                              </td>
                              <td>
                                  <span class="badge badge-primary" v-if="u.type === 'purchasing'">{{ u.type }}</span>
                                  <span class="badge badge-success" v-else-if="u.type === 'sales'">{{ u.type }}</span>
                              </td>
                              <td>
                                <span class="badge badge-primary" v-if="u.category === 'others'">{{ u.category }}</span>
                                <span class="badge badge-danger" v-else-if="u.category === 'cancel'">Batal Salesman</span>
                              </td>
                              <td>
                                <span @click="editData(u.id)" style="color: blue; cursor: pointer">{{ u.return_no }}</span>
                              </td>
                              <td>{{ u.return_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td>{{ u.sale_no }}</td>
                              <td>{{ u.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td>{{ u.company }}</td>
                              <td>{{ u.customer }}</td>
                              <td>{{ u.salesman }}</td>
                              <td>{{ u.notes }}</td>
                              <td class="text-right">{{ u.total | currency }}</td>
                              <td class="text-right">{{ u.total_detail | currency }}</td>
                              <td class="text-right">
                                <span class="badge badge-danger" v-if="u.total !== u.total_journal">{{ u.total_journal | currency }}</span>
                                <span v-else>{{ u.total_journal | currency }}</span>
                              </td>
                          </tr>
                        </tbody>
                    </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <pre>{{ dataRaw }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import DatePicker from 'vue2-datepicker'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import { getHeader, returnUrl } from '../../config'

export default {
  name: 'SaleReturnList',
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      filterCompany: [],
      startDate: [date1, date2],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Status',
        prop: 'status',
        align: 'text-left'
      }, {
        name: 'Type',
        prop: 'type',
        align: 'text-left'
      }, {
        name: 'Category',
        prop: 'category',
        allign: 'text-left'
      }, {
        name: 'Return No.',
        prop: 'return_no',
        align: 'text-left'
      }, {
        name: 'Date',
        prop: 'return_date',
        align: 'text-left'
      }, {
        name: 'Sale No.',
        prop: 'sale_no',
        align: 'text-left'
      }, {
        name: 'Sale Date',
        prop: 'sale_date',
        align: 'text-left'
      }, {
        name: 'Company',
        prop: 'company_no',
        align: 'text-left'
      }, {
        name: 'Customer',
        prop: 'customer',
        align: 'text-left'
      }, {
        name: 'Salesman',
        prop: 'salesman',
        align: 'text-left'
      }, {
        name: 'Note',
        prop: 'notes',
        align: 'text-left'
      }, {
        name: 'Total',
        prop: 'total',
        align: 'text-right'
      }, {
        name: 'Total Detail',
        prop: 'total_detail',
        align: 'text-right'
      }, {
        name: 'Total Journal',
        prop: 'total_journal',
        align: 'text-right'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshList()
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList
    }),
    totalRetur () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalJournal () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_journal)
      }
      return sum
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        if (this.filterCompany.length > 0) {
          var array = this.filterCompany
          for (let i = 0; i < array.length; i++) {
            console.log(array[i])
            if (d.company_no === array[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async editData (id) {
      console.log(returnUrl + '/' + id)
      await axios.get(returnUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$emit('editSales', response.data.data)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    addReturn () {
      this.$emit('newSales', true)
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = returnUrl + '?begin=' + begin + '&end=' + end + '&type=sales'
      axios.get(url, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>

<style>
.overdue {
  background-color: rgb(185, 93, 93);
  color: white;
}
</style>
